<template>
  <div class="big-box">
    <div class="scroll-box">
      <img
        class="layout-img"
        src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png"
        alt=""
      />
      <img :src="backgroundImage" alt="" class="big-box-img" />
      <!-- <img :src="'https://cdn-image.yucrm.cn//hd/images/13315956_dbb5f5fedeff4168aa8c3869f419f7b9.png'" alt="" class="big-box-img" /> -->
      <div class="big-body">
        <!-- <img :src="tapTopUrl" alt="" class="tap-top" /> -->
        <div class="pd8">
          <!-- 主题文字 -->
          <div
            class="theme-word"
            :style="`color: ${customerPaperwork.titleColor};`"
          >
            <div class="title">{{ customerPaperwork.title }}</div>
            <div class="desc">{{ customerPaperwork.desc }}</div>
          </div>
          <div style="width:100%;padding:0 8px;margin-top:18px;">
            <img
            v-if="customerPaperwork.layout == 1"
            style="width:100%"
            src="https://cdn-image.yucrm.cn//hd/images/13315956_0eed90d4716a4e36b23f48dbc3e0a531.png"
            alt=""
            />

            <img
            v-if="customerPaperwork.layout == 2"
            style="width:100%"
            src="https://cdn-image.yucrm.cn//hd/images/13315956_b3668b9cd6964e61863fad94d8139ac7.png"
            alt=""
            />
          </div>

          <div class="prize-box">
            <div style="position: relative;border-radius: 8px;overflow: hidden;">
              <img :src="currentPrize.logo" alt="" />
              <div class="stock" v-if="customerPaperwork.showStock">剩余9999件</div>
            </div>
            <div class="title">{{ currentPrize.title }}</div>
            <div v-if="customerPaperwork.showPrice" style="color:#FF4747;font-size:12px;margin-top:3px;"><span style="font-size:9px;">价值￥</span>{{ currentPrize.price }}</div>
          </div>

          <div class="countdown">
            <span>距活动开始还有</span>
            <span class="count-item">30</span>
            <span>天</span>
            <span class="count-item">00</span>
            <span>:</span>
            <span class="count-item">00</span>
            <span>:</span>
            <span class="count-item">00</span>
          </div>
          
          <div class="tab-list">
            <div style="display:flex;position:absolute;width:100%;">
              <div class="tab-item activ-tab">
                <img v-if="customerPaperwork.layout == 1" src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260709/e962026a7a174b009d9fdb1d0f5d15a8.png">
                <img v-if="customerPaperwork.layout == 2" src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260710/8437add362d348bcb4f66dbf82784f7c.png">
                <span :style="customerPaperwork.layout == 2? 'color:#1A1A1A;' : ''">精选内容</span>
                <img v-if="customerPaperwork.layout == 1" src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260709/0ec929c07548478581152700f44669ce.png">
                <img v-if="customerPaperwork.layout == 2" src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260710/e0b943eb54764cdaae636892582cb5c6.png">
              </div>
              <div class="tab-item">
                <span :style="customerPaperwork.layout == 2? 'color:#1A1A1A;' : ''">排行榜</span>
              </div>
              <div class="tab-item">
                <span :style="customerPaperwork.layout == 2? 'color:#1A1A1A;' : ''">我的晒单</span>
              </div>
            </div>
              <img src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260710/516f84c5967e49ba902fbb05c0aeae15.png" class="tab-activ-img" style="opacity: 0.05;">
              <div style="width:100%;height: 434px;padding: 10px 0;background: #ffffff18;border-radius: 0 0 0 0;position: relative;margin-top:32px;display: flex;">
                <div style="width: calc(50% - 12px);height: 196px;border-radius: 4px 4px 4px 4px;display: inline-block;margin-left: 8px;margin-bottom: 8px;overflow: hidden;">
                  <img src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260710/ae3a8030927e467b805401495e57e1c4.png">
                </div>
                <div style="width: calc(50% - 12px);height: 196px;border-radius: 4px 4px 4px 4px;display: inline-block;margin-left: 8px;margin-bottom: 8px;overflow: hidden;">
                  <img src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260710/ae3a8030927e467b805401495e57e1c4.png">
                </div>
              </div>
          </div>

        </div>
      </div>
      <div class="main-btn">
        <!-- <div class="main-btn" v-if="btnUrl"> -->
        <img :src="btnUrl" alt=""/>
        <!-- <img :src="'https://cdn-image.yucrm.cn//hd/images/13315956_29b13828c1054b8e9bc7831a973067b5.png'" alt=""/> -->
        <div class="btn-word" :style="`color: ${customerPaperwork.btnColor};`">
          立即报名
        </div>
        <img
          class="bargain-btn-icon"
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/sweep-light.svg"
          alt=""
        />
      </div>



    </div>
    <div class="footer-title">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    productList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
      currentObj: {},
      currentPrize: [],
      prizeList: [],
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
    };
  },
  computed: {
    btnUrl() {
      return this.customerPaperwork.url2
        ? this.customerPaperwork.url2
        : this.templateObj.url2;
    },
    navList() {
      const sortType = {
        0: "一",
        1: "二",
        2: "三",
        3: "四",
        4: "五",
        5: "六",
        6: "七",
        7: "八",
        8: "九",
        9: "十",
        10: "十一",
        11: "十二",
        12: "十三",
        13: "十四",
        14: "十五",
        15: "十六",
        16: "十七",
        17: "十八",
        18: "十九",
        19: "二十",
      };
      return this.productList.map((item, index) => {
        let obj = {
          rankStart: item.scoreRankWinConditionDTO.rankStart,
          rankEnd: item.scoreRankWinConditionDTO.rankEnd,
          rankNum: item.scoreRankWinConditionDTO.rankNum,
          firstText: `${sortType[index]}等奖`,
          secondText:
            item.scoreRankWinConditionDTO.winType == 0
              ? `TOP${item.scoreRankWinConditionDTO.rankStart}-${item.scoreRankWinConditionDTO.rankEnd}`
              : ` TOP${item.scoreRankWinConditionDTO.rankNum}`,
        };
        return obj;
      });
    },
    selectUrl() {
      return this.customerPaperwork.url2
        ? this.customerPaperwork.url2
        : this.templateObj.url2;
    },
    selectStyle() {
      return `background: url(${this.selectUrl}); no-repeat;background-size: 65px 26px;color:${this.customerPaperwork.selectColor};`;
    },
    navStyle() {
      return `background: ${this.hexToRgba(
        this.customerPaperwork.unSelectBgColor,
        this.customerPaperwork.navOpacity
      )};color:${this.customerPaperwork.unSelectColor};`;
    },
  },
  watch: {
    productList: {
      handler(newVal, oldVal) {
        this.currentPrize = newVal[this.currentIndex];
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    handleChange(index) {
      this.currentIndex = index;
      this.currentPrize = this.productList[index];
    },
    // 将十六进制颜色转换为rgba格式，支持透明度设置，透明度不影响子元素
    hexToRgba(hex, opacity) {
      if (!hex) return "rgba(255,255,255,1)";
      // 处理简写形式 #fff => #ffffff
      let color = hex.replace("#", "");
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const a = opacity / 100;
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    },
  },
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;

  .scroll-box {
    position: relative;
    width: 284px;
    height: 560px;
    overflow: hidden;
    border-radius: 24px;
    .layout-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
    }
  }
  .big-box-img {
    border-radius: 24px;
    width: 100%;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tap-top {
      width: 100%;
    }
    .pd8 {
      position: absolute;
      top: 88px;
      width: 100%;
      height: 100%;
      // margin-top: 18px;
      // padding: 8px;
      box-sizing: border-box;
      position: relative;
      .theme-word {
        // position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        // top: 18px;
        width: 100%;
        > div:first-child {
          height: 16px;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 10px;
        }
        > div:last-child {
          margin: 0 auto;
          text-align: center;
          width: 65%;
          height: 11px;
          line-height: 12px;
          font-size: 11px;
          opacity: 0.7;
        }
      }
      .nav-box {
        position: relative;
        margin: 14px auto;
        width: 248px;
        height: 30px;
        border-radius: 50px 50px 50px 50px;
        overflow-y: hidden;
        overflow-x: auto;
        cursor: pointer;
        &::-webkit-scrollbar {
          width: 2px;
          height: 2px;
        }
        .nav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 65px;
          height: 26px;
          flex-shrink: 0;
          font-size: 9px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          &_desc {
            padding: 0 3px;
            width: 100%;
            opacity: 0.5;
            margin-top: 2px;
            font-size: 8px;
            text-align: center;
            // 一行展示
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .flex-c {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .flex-box {
        display: flex;
        align-items: center;
      }
      .prize-box {
        margin: 20px auto 0 auto;
        width: 114px;
        height: 151px;
        padding: 5px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.06);
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 107px;
          height: 107px;
          border-radius: 12px;
          object-fit: cover;
        }
        .title {
          margin-top: 6px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          line-height: 12px;
          color: #1a1a1a;
          text-align: center;
          font-style: normal;
          text-transform: none;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .main-btn {
    position: sticky;
    left: 13%;
    bottom: 145px;
    width: 219px;
    height: 37px;
    // background: #ffffff;
    border-radius: 25px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .btn-word {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;
      line-height: 12px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .bargain-btn-icon {
      width: 215px;
      height: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      animation: identifier 2s infinite;
      border-radius: 19px 19px 19px 19px;
    }
    @keyframes identifier {
      0% {
        transform: translateX(-30px);
      }
      100% {
        transform: translateX(100%);
      }
    }
  }
  .footer-title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}
.countdown{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    text-align: center;
    font-weight: 400;
    font-size: 9px;
    color: #fff;
    position: absolute;
    bottom: 207px;
    .count-item{
        width: 15px;
        height: 15px;
        margin: 0 3px;
        line-height: 15px;
        background: hsla(0, 0%, 100%, .1);
        border-radius: 3px 3px 3px 3px;
    }
}
.tab-list{
  width: 100%;
  height: 32px;
  margin-top: 13px;
  background: hsla(0, 0%, 100%, .05);
  border-radius: 10px 10px 0 0;
  color: hsla(0, 0%, 100%, .6);
  position: absolute;
  top: 355px;
  .tab-activ-img{
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
  }
  .tab-item{
    flex: 1;
    height: 100%;
    font-size: 11px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    img{
      width: 16px;
      height: 16px;
    }
    // cursor: pointer;
  }
}
.stock{
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  background: rgba(0,0,0,0.5);
  font-weight: 400;
  font-size: 10px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
}
</style>
